import Seo from "@/components/seo/Seo";
import JsonLd from "@/components/seo/JsonLd";
import { breadcrumbLd } from "@/data/schema";
import PageHero from "@/components/layout/PageHero";
import Features from "@/components/home/Features";
import AIStack from "@/components/home/AIStack";
import HowItWorks from "@/components/home/HowItWorks";
import CtaBand from "@/components/layout/CtaBand";

export default function FeaturesPage() {
    return (
        <>
            <Seo
                title="Funkcje"
                path="/features"
                description="Funkcje Groszownika: KSeF FA-2, KPiR autopilot, OCR AI, AI Doradca, VAT-OSS, AI Briefing, auto QR do ZUS/US i ZUS Wakacje 2026 — wszystko w telefonie."
            />
            <JsonLd data={breadcrumbLd([{ name: "Start", path: "/" }, { name: "Funkcje", path: "/features" }])} />
            <PageHero
                eyebrow="Funkcje"
                title="Osiem narzędzi, które robią księgowość za Ciebie"
                subtitle="Od faktur ustrukturyzowanych KSeF po automatyczne kody QR do podatków. Zobacz, co potrafi Groszownik."
            />
            <Features />
            <AIStack />
            <HowItWorks />
            <CtaBand />
        </>
    );
}
